import React, {useState} from "react";
import ReactDOM from "react-dom";
import * as noScroll from "no-scroll";
import Icon from "../../components/Icon";
import _ from "lodash";
import "./NewsletterGuest.scss";
import argument1 from "./images/pngegg.png";
import {useMutation} from "@tanstack/react-query";
import {createNewsletterGuest} from "../../../api/public-voissa/guest";
import {SpinLoader} from "../Loader";


const NewsletterGuest = ({
            handleClose = () =>{}
      }) => {

    const [email, setEmail] = useState("");
    const [cgu, setCgu] = useState(false);
    const [message, setMessage] = useState("");

    const {
        isError : isErrorSignupNewsletter,
        error : errorSignupNewsletter,
        mutate : mutateSignupNewsletter,
        isLoading : isLoadingSignupNewsletter
    } = useMutation((data) => createNewsletterGuest(data),{
        onSuccess: async (data) =>{
            localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_signup`, "1");
             setMessage("Votre email a bien été enregistré ! Veuillez vérifier vos emails.");
            //handleClose();
        },
        onError: (data) =>{
            if(data.statusCode === 409){
                localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_ms_signup`, "1");
                setMessage("Votre email est déjà inscrit à la newsletter");
            }
            else{
                setMessage("");
            }
        }
    });

    return (
        <div id={"newsletter-guest"}>
            <div className="full-bg">

            </div>
            <div className="center">
                <div className="container-signup">
                    <div className="header">
                        <div className="close-mobile">
                            <Icon type={"close-x"} callback={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="window-wrapper">
                        <div className="window">
                            <div className="close-desktop">
                                <Icon type={"close-x"} callback={()=>handleClose()} />
                            </div>
                            <div className="illustration"></div>
                            <div className="main-section">
                                <div className="form">
                                    <h2>J'inscris mon email pour <br /><strong>recevoir les nouveaux contenus de Voissa !</strong></h2>
                                    <ul className="arguments">
                                        <li>
                                            <div className="icon border-icon">
                                                <img alt={""} src={argument1} />
                                            </div>
                                            <input
                                                type={"email"}
                                                className={"input-mail"}
                                                placeholder={"ex : mon@mail.com"}
                                                value={email}
                                                onChange={(event) => setEmail(event.target.value)}
                                            />

                                        </li>
                                    </ul>
                                    {isErrorSignupNewsletter && _.get(errorSignupNewsletter, 'errors.email') ? <div className={"error-text"}>{errorSignupNewsletter.errors.email}</div> : null}


                                    <div className={"cgu"}>
                                        <input type={"checkbox"} id={"cgu"} value={cgu} onClick={() => setCgu(!cgu)} />
                                        <label htmlFor={"cgu"}>J'ai lu et j'accepte les termes d'utilisation*</label>
                                    </div>
                                    <div className="cta-list">
                                        <div className={`signup-cta ${!email.length || !cgu ? "disable" : ""}`} onClick={() => email.length && cgu ? mutateSignupNewsletter({email}) : null}>
                                            JE M'INSCRIS A LA NEWSLETTER
                                        </div>
                                    </div>
                                    {isLoadingSignupNewsletter ? <div className={"custom-loader"}><SpinLoader /></div> : null}
                                    {message.length ? <div className={"success-text"}>{message}</div> : null}
                                </div>
                                <div className="text">
                                    En m'inscrivant à cette newsletter je ne deviens pas membre de voissa et je ne peux pas publier mes propres contenus, laisser des commentaires, suivre mes membres préférés ou discuter avec eux.
                                    <br />
                                    A tout moment je peux changer mes préférences et me désabonner de cette newsletter
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

class ModalNewsLetterGuest extends React.Component {
    constructor(props){
        super(props);

        if (document.getElementById("modal").childElementCount >= 1) {
            noScroll.on();
        }
    }
    componentDidUpdate() {
        if (document.getElementById("modal").childElementCount >= 1) {
            noScroll.on();
        }
        if (document.getElementById("modal").childElementCount < 1) {
            noScroll.off();
        }
    }

    componentWillUnmount() {
        if (document.getElementById("modal").childElementCount < 1) {
            noScroll.off();
        }
    };

    render() {
        return ReactDOM
            .createPortal(
                this.props.toggle ? <NewsletterGuest {...this.props} /> : null,
                document.querySelector("#modal")
            );
    }
}

export default ModalNewsLetterGuest;